
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33981',
  depVersions: {
  "documents-public-ui": "static-1.33981",
  "client-types": "static-1.445",
  "documents-lib": "static-1.33986",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1929",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5397",
  "hs-test-utils": "static-1.7809",
  "hub-http": "static-1.6024",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11234",
  "I18n": "static-7.1571",
  "jasmine-immutable": "static-1.2822",
  "jasmine-runner": "static-1.6276",
  "lodash": "static-1.3",
  "quartz": "static-1.6741",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16453",
  "reporting-data": "static-1.66536",
  "reporting-testing-lib": "static-1.8469",
  "reporting-visualizations": "static-1.58612",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4569",
  "webpack-env": "static-1.54",
  "atom": "static-1.4873",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2289",
  "classnames": "static-2.10",
  "cssUtils": "static-1.733",
  "customer-data-filters-ui": "static-1.38924",
  "customer-data-objects": "static-1.7453",
  "customer-data-property-utils": "static-1.7881",
  "data-fetching-client": "static-1.9482",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4332",
  "flux-actions": "static-1.309",
  "FormsCommonComponents": "static-1.85299",
  "FormUrlGenerator": "static-2.4533",
  "foundations-components": "static-1.7529",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11542",
  "icons": "static-2.622",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6964",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3663",
  "property-translator": "static-1.5217",
  "quartz-config": "static-1.519",
  "quartz-core": "static-1.5960",
  "quick-fetch": "static-1.3738",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5176",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7964",
  "reference-resolvers-lite": "static-1.7898",
  "report-customization-components": "static-1.12506",
  "reporting-enablement": "static-1.22085",
  "reporting-reports": "static-1.66214",
  "reporting-snowflake": "static-1.55154",
  "reporting-ui-components": "static-2.63807",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4438",
  "sales-content-partitioning": "static-1.8739",
  "SalesContentIndexUI": "static-3.8906",
  "sanitize": "static-1.4278",
  "sanitize-text": "static-1.7944",
  "self-service-api": "static-1.10037",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1557",
  "signup-constants": "static-1.18411",
  "signup-ui-lego-core": "static-1.20421",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4573",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10798",
  "ui-addon-i18n": "static-1.10942",
  "ui-addon-react-router-dom": "static-1.9350",
  "ui-addon-upgrades": "static-9.17662",
  "ui-asset-management-lib": "static-1.10713",
  "ui-images": "static-2.1093",
  "UIComponents": "static-3.8181",
  "usage-tracker": "static-1.7138",
  "usage-tracker-container": "static-1.7128",
  "usage-tracker-core": "static-1.6988",
  "usage-tracker-public": "static-1.6949",
  "viral-links-lib": "static-1.6839",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3231",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3018",
  "quartz-webpack": "static-1.2965",
  "ai-components-ui-library": "static-1.8357",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4640",
  "foundations-theming": "static-1.4213",
  "quartz-auth": "static-1.416",
  "ui-business-units-lib": "static-1.8831",
  "usage-tracker-session-replay": "static-1.4824",
  "foundations-theming-base": "static-1.3198",
  "HeadJS": "static-2.710",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2920",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4130",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7728",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3420",
  "persist-promise": "static-1.3512",
  "reporting-client-types": "static-1.2385",
  "foundations-components-legacy": "static-1.554",
  "hs-story-utils": "static-1.9231",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9483",
  "hubspotter-http": "static-1.4481",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7051",
  "crm-message-bus": "static-1.42379",
  "customer-data-filters-ui-msw-helpers": "static-1.21359",
  "customer-data-objects-ui-components": "static-1.12811",
  "customer-data-reference-ui-components": "static-1.12949",
  "customer-data-ui-utilities": "static-1.9627",
  "framework-builder-read-service-client": "static-1.3836",
  "framework-data-schema-quick-fetch": "static-1.6582",
  "framework-data-schema-resolvers": "static-1.6677",
  "inbound-db-properties-service-client": "static-1.3678",
  "multi-account-reference-resolvers": "static-1.778",
  "onboarding-tours": "static-1.16263",
  "reporting-datasets-permissions-lib": "static-1.13060",
  "ui-addon-teams": "static-1.21247",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67635",
  "customer-data-properties": "static-1.50812",
  "forms-ai-lib": "static-1.4014",
  "forms-utils-lib": "static-1.12171",
  "foundations-components-test-utils": "static-1.5012",
  "react-dnd-compat": "static-1.4424",
  "react-tinymce": "static-1.54631",
  "tinymce-config": "static-2.53757",
  "ui-gdpr-components": "static-1.10151",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3798",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1206",
  "ui-fonts": "static-1.496",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.795",
  "mobile-manifest-mixins": "static-1.483",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.406",
  "quartz-i18n": "static-1.416",
  "quartz-routing": "static-1.171",
  "quartz-test": "static-1.416",
  "quartz-tracking": "static-1.120",
  "batch-promise": "static-1.1355",
  "external-options-client-types": "static-1.3987",
  "react-colorpicker": "static-2.10013",
  "copilot-toolkit": "static-1.10541",
  "data-quality-ui-library": "static-1.12328",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40666",
  "reporting-insights-lib": "static-1.1176",
  "reporting-plugins": "static-1.9988",
  "ui-addon-draggable-compat": "static-2.4057",
  "ui-addon-opt": "static-4.8188",
  "ui-shepherd-react": "static-3.9949",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24742",
  "hubspot-apollo-client": "static-1.4685",
  "sales-templates-service-types-lib": "static-1.3994",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5488",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3907",
  "timezone-utils": "static-2.5048",
  "bender-build-tools": "static-1.2947",
  "chatspot-core": "static-1.20326",
  "chirp-fetch": "static-1.1686",
  "bend-plugin-foundations-theming": "static-1.2696",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9481",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3626",
  "crm-pipelines-api-client-types": "static-1.3967",
  "multi-currency-client-types": "static-1.3520",
  "getting-started-shared-tasks": "static-1.17897",
  "growth-data-modal": "static-1.5160",
  "growth-onboarding-confetti": "static-1.2875",
  "growth-onboarding-next-action-utils": "static-1.1302",
  "navigation-components": "static-1.17280",
  "onboarding-tours-client": "static-1.4477",
  "onboarding-tours-utils": "static-1.329",
  "ui-shepherd-tracker": "static-1.7330",
  "ui-universal-auth": "static-1.8704",
  "user-context": "static-1.4903",
  "cms-field-types": "static-1.4610",
  "content-icons-ui": "static-1.2155",
  "integrations-lib": "static-1.15427",
  "calling-global-api": "static-1.63680",
  "calling-internal-common": "static-1.31097",
  "calling-lifecycle-internal": "static-1.65062",
  "calling-lifecycle-messages": "static-1.57356",
  "commerce-products-lib": "static-1.8872",
  "crm-links": "static-1.6069",
  "file-manager-components": "static-1.22897",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.482",
  "inbounddb-objects-service-types": "static-1.4052",
  "meetings-icalendar-utils-lib": "static-1.437",
  "object-builder-ui-client": "static-1.47994",
  "pipeline-validation-client-types": "static-1.3789",
  "property-value-citations": "static-1.1426",
  "pulse": "static-1.316",
  "smart-property-lib": "static-1.5920",
  "tiered-pricing": "static-1.834",
  "ui-addon-iframeable": "static-1.8848",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19473",
  "tinymce-themes": "static-1.55727",
  "data-token-picker": "static-1.16046",
  "hub-http-contrib": "static-1.2847",
  "interframe": "static-3.4594",
  "tinymce-data": "static-1.39842",
  "tinymce-plugins": "static-1.56871",
  "ui-addon-sales-email": "static-1.5017",
  "magpie-lib": "static-1.5397",
  "magpie-types": "static-1.4857",
  "simple-logging-lib": "static-1.2854",
  "content-assistance-lib": "static-1.7454",
  "dashboard-lib": "static-1.80641",
  "ExportDialog": "static-6.10190",
  "hubspot-prosemirror": "static-1.17616",
  "hubspot-prosemirror-plugins": "static-1.17608",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8495",
  "campaign-roi-lib": "static-1.8285",
  "feedback-loader": "static-1.28860",
  "onboarding-scopes": "static-1.6267",
  "apollo-link-hub-http": "static-2.4453",
  "hubspot-apollo-cache": "static-1.144",
  "growth-monetization-service-types": "static-1.4317",
  "nav-client-types": "static-1.2161",
  "purchase-motions-api": "static-1.5491",
  "trials-service-types": "static-1.3718",
  "growth-onboarding-next-action-components": "static-1.1330",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.529",
  "unified-auth-core-lib": "static-1.499",
  "getting-started-shared-tasks-store": "static-1.17015",
  "integrations-error-boundary-lib": "static-1.12842",
  "integrations-tracking-lib": "static-1.5393",
  "native-integrations-shared-strings": "static-1.7592",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10175",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31103",
  "shared-worker-versioning": "static-1.10842",
  "calling-usage-tracker": "static-1.6344",
  "voice-sms-access-library": "static-1.261",
  "customer-data-tracking": "static-1.6686",
  "commerce-permissions": "static-1.561",
  "products-iframe-lib": "static-1.7328",
  "products-ui-components-shared-msw-handlers": "static-1.9865",
  "location-customization-utils-lib": "static-1.8575",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3958",
  "video-components-external": "static-1.10573",
  "video-data-lib": "static-1.34231",
  "directed-graph": "static-1.740",
  "event-emitter": "static-1.751",
  "breeze-intelligence-kit": "static-1.5326",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9566",
  "fsm": "static-1.3534",
  "policy-lib": "static-1.6587",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9629",
  "navigation-messaging": "static-1.6607",
  "FileManagerLib": "static-1.38537",
  "NamespacedHubStyle": "static-2.8899",
  "FileManagerCore": "static-1.38396",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12037",
  "layout-dnd-utils": "static-1.11012",
  "react-codemirror": "static-1.10430",
  "ui-addon-emoji-picker": "static-1.9692",
  "ui-brand-identity-lib": "static-1.13898",
  "ui-addon-video-player": "static-1.8500",
  "ui-coaching-tips": "static-1.27956",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8372",
  "payment-link-components": "static-1.22952",
  "EmailSignatureEditor": "static-1.23916",
  "eligibility-engine-service-types": "static-1.2999",
  "universal-page-editor-lib": "static-1.2803",
  "calling-orchestration-schema": "static-1.35038",
  "sales-views-client-types": "static-1.4091",
  "crm-record-cards-service-types": "static-1.3455",
  "content-media-composition-data-lib": "static-1.11466",
  "content-media-compositions": "static-2.15473",
  "media-bridge-lib": "static-1.18569",
  "trellis-story-utils": "static-1.4325",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5618",
  "FileManagerImages": "static-1.36048",
  "video-components": "static-1.12576",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4337",
  "video-embed": "static-1.35065",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67710",
  "layout-data-lib": "static-1.9337",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6387",
  "commerce-tours-lib": "static-1.5724",
  "growth-onboarding-reliability": "static-1.4890",
  "sales-checkout-service-client": "static-1.3472",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21311",
  "sales-email-signature-service-client": "static-1.3648",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21347",
  "outpost": "static-1.4008",
  "advanced-menus-core": "static-1.14819",
  "advanced-menus-lib": "static-1.11793",
  "ui-memberships-settings-lib": "static-1.33437",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14818",
  "simple-menus-lib": "static-1.16335"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33981",
  "client-types": "/client-types/static-1.445",
  "documents-lib": "/documents-lib/static-1.33986",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1929",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5397",
  "hs-test-utils": "/hs-test-utils/static-1.7809",
  "hub-http": "/hub-http/static-1.6024",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11234",
  "I18n": "/I18n/static-7.1571",
  "jasmine-immutable": "/jasmine-immutable/static-1.2822",
  "jasmine-runner": "/jasmine-runner/static-1.6276",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6741",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16453",
  "reporting-data": "/reporting-data/static-1.66536",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8469",
  "reporting-visualizations": "/reporting-visualizations/static-1.58612",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4569",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4873",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2289",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.733",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38924",
  "customer-data-objects": "/customer-data-objects/static-1.7453",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7881",
  "data-fetching-client": "/data-fetching-client/static-1.9482",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4332",
  "flux-actions": "/flux-actions/static-1.309",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85299",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4533",
  "foundations-components": "/foundations-components/static-1.7529",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11542",
  "icons": "/icons/static-2.622",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6964",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3663",
  "property-translator": "/property-translator/static-1.5217",
  "quartz-config": "/quartz-config/static-1.519",
  "quartz-core": "/quartz-core/static-1.5960",
  "quick-fetch": "/quick-fetch/static-1.3738",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5176",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7964",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7898",
  "report-customization-components": "/report-customization-components/static-1.12506",
  "reporting-enablement": "/reporting-enablement/static-1.22085",
  "reporting-reports": "/reporting-reports/static-1.66214",
  "reporting-snowflake": "/reporting-snowflake/static-1.55154",
  "reporting-ui-components": "/reporting-ui-components/static-2.63807",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4438",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8739",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8906",
  "sanitize": "/sanitize/static-1.4278",
  "sanitize-text": "/sanitize-text/static-1.7944",
  "self-service-api": "/self-service-api/static-1.10037",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1557",
  "signup-constants": "/signup-constants/static-1.18411",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20421",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4573",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10798",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10942",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9350",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17662",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10713",
  "ui-images": "/ui-images/static-2.1093",
  "UIComponents": "/UIComponents/static-3.8181",
  "usage-tracker": "/usage-tracker/static-1.7138",
  "usage-tracker-container": "/usage-tracker-container/static-1.7128",
  "usage-tracker-core": "/usage-tracker-core/static-1.6988",
  "usage-tracker-public": "/usage-tracker-public/static-1.6949",
  "viral-links-lib": "/viral-links-lib/static-1.6839",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3231",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3018",
  "quartz-webpack": "/quartz-webpack/static-1.2965",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8357",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4640",
  "foundations-theming": "/foundations-theming/static-1.4213",
  "quartz-auth": "/quartz-auth/static-1.416",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8831",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4824",
  "foundations-theming-base": "/foundations-theming-base/static-1.3198",
  "HeadJS": "/HeadJS/static-2.710",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2920",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4130",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7728",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3420",
  "persist-promise": "/persist-promise/static-1.3512",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.554",
  "hs-story-utils": "/hs-story-utils/static-1.9231",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9483",
  "hubspotter-http": "/hubspotter-http/static-1.4481",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7051",
  "crm-message-bus": "/crm-message-bus/static-1.42379",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21359",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12811",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12949",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9627",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3836",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6582",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6677",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3678",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.778",
  "onboarding-tours": "/onboarding-tours/static-1.16263",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13060",
  "ui-addon-teams": "/ui-addon-teams/static-1.21247",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67635",
  "customer-data-properties": "/customer-data-properties/static-1.50812",
  "forms-ai-lib": "/forms-ai-lib/static-1.4014",
  "forms-utils-lib": "/forms-utils-lib/static-1.12171",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5012",
  "react-dnd-compat": "/react-dnd-compat/static-1.4424",
  "react-tinymce": "/react-tinymce/static-1.54631",
  "tinymce-config": "/tinymce-config/static-2.53757",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10151",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3798",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1206",
  "ui-fonts": "/ui-fonts/static-1.496",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.795",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.483",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.406",
  "quartz-i18n": "/quartz-i18n/static-1.416",
  "quartz-routing": "/quartz-routing/static-1.171",
  "quartz-test": "/quartz-test/static-1.416",
  "quartz-tracking": "/quartz-tracking/static-1.120",
  "batch-promise": "/batch-promise/static-1.1355",
  "external-options-client-types": "/external-options-client-types/static-1.3987",
  "react-colorpicker": "/react-colorpicker/static-2.10013",
  "copilot-toolkit": "/copilot-toolkit/static-1.10541",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12328",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40666",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1176",
  "reporting-plugins": "/reporting-plugins/static-1.9988",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4057",
  "ui-addon-opt": "/ui-addon-opt/static-4.8188",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9949",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24742",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4685",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3994",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5488",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3907",
  "timezone-utils": "/timezone-utils/static-2.5048",
  "bender-build-tools": "/bender-build-tools/static-1.2947",
  "chatspot-core": "/chatspot-core/static-1.20326",
  "chirp-fetch": "/chirp-fetch/static-1.1686",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2696",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9481",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3626",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3967",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3520",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17897",
  "growth-data-modal": "/growth-data-modal/static-1.5160",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2875",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1302",
  "navigation-components": "/navigation-components/static-1.17280",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4477",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.329",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7330",
  "ui-universal-auth": "/ui-universal-auth/static-1.8704",
  "user-context": "/user-context/static-1.4903",
  "cms-field-types": "/cms-field-types/static-1.4610",
  "content-icons-ui": "/content-icons-ui/static-1.2155",
  "integrations-lib": "/integrations-lib/static-1.15427",
  "calling-global-api": "/calling-global-api/static-1.63680",
  "calling-internal-common": "/calling-internal-common/static-1.31097",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65062",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57356",
  "commerce-products-lib": "/commerce-products-lib/static-1.8872",
  "crm-links": "/crm-links/static-1.6069",
  "file-manager-components": "/file-manager-components/static-1.22897",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.482",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4052",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.437",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47994",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3789",
  "property-value-citations": "/property-value-citations/static-1.1426",
  "pulse": "/pulse/static-1.316",
  "smart-property-lib": "/smart-property-lib/static-1.5920",
  "tiered-pricing": "/tiered-pricing/static-1.834",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8848",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19473",
  "tinymce-themes": "/tinymce-themes/static-1.55727",
  "data-token-picker": "/data-token-picker/static-1.16046",
  "hub-http-contrib": "/hub-http-contrib/static-1.2847",
  "interframe": "/interframe/static-3.4594",
  "tinymce-data": "/tinymce-data/static-1.39842",
  "tinymce-plugins": "/tinymce-plugins/static-1.56871",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5017",
  "magpie-lib": "/magpie-lib/static-1.5397",
  "magpie-types": "/magpie-types/static-1.4857",
  "simple-logging-lib": "/simple-logging-lib/static-1.2854",
  "content-assistance-lib": "/content-assistance-lib/static-1.7454",
  "dashboard-lib": "/dashboard-lib/static-1.80641",
  "ExportDialog": "/ExportDialog/static-6.10190",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17616",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17608",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8495",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8285",
  "feedback-loader": "/feedback-loader/static-1.28860",
  "onboarding-scopes": "/onboarding-scopes/static-1.6267",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4453",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.144",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4317",
  "nav-client-types": "/nav-client-types/static-1.2161",
  "purchase-motions-api": "/purchase-motions-api/static-1.5491",
  "trials-service-types": "/trials-service-types/static-1.3718",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1330",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.529",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.499",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17015",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12842",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5393",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7592",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10175",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31103",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10842",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6344",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.261",
  "customer-data-tracking": "/customer-data-tracking/static-1.6686",
  "commerce-permissions": "/commerce-permissions/static-1.561",
  "products-iframe-lib": "/products-iframe-lib/static-1.7328",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9865",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8575",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3958",
  "video-components-external": "/video-components-external/static-1.10573",
  "video-data-lib": "/video-data-lib/static-1.34231",
  "directed-graph": "/directed-graph/static-1.740",
  "event-emitter": "/event-emitter/static-1.751",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5326",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9566",
  "fsm": "/fsm/static-1.3534",
  "policy-lib": "/policy-lib/static-1.6587",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9629",
  "navigation-messaging": "/navigation-messaging/static-1.6607",
  "FileManagerLib": "/FileManagerLib/static-1.38537",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8899",
  "FileManagerCore": "/FileManagerCore/static-1.38396",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12037",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11012",
  "react-codemirror": "/react-codemirror/static-1.10430",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9692",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13898",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8500",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27956",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8372",
  "payment-link-components": "/payment-link-components/static-1.22952",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23916",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2999",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2803",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35038",
  "sales-views-client-types": "/sales-views-client-types/static-1.4091",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3455",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11466",
  "content-media-compositions": "/content-media-compositions/static-2.15473",
  "media-bridge-lib": "/media-bridge-lib/static-1.18569",
  "trellis-story-utils": "/trellis-story-utils/static-1.4325",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5618",
  "FileManagerImages": "/FileManagerImages/static-1.36048",
  "video-components": "/video-components/static-1.12576",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4337",
  "video-embed": "/video-embed/static-1.35065",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67710",
  "layout-data-lib": "/layout-data-lib/static-1.9337",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6387",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5724",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4890",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3472",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21311",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3648",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21347",
  "outpost": "/outpost/static-1.4008",
  "advanced-menus-core": "/advanced-menus-core/static-1.14819",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11793",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33437",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14818",
  "simple-menus-lib": "/simple-menus-lib/static-1.16335"
}
};
